import { DoNothingState } from "@redotech/redo-return-ui/flows/return-flow/do-nothing";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { memo } from "react";

export const DoNothingDetails = memo(function DoNothingDetails({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<DoNothingState>) {
  return null;
});
